module.exports = __webpack_public_path__ + "img/vko3.ef60654c.jpg";